import type { ComponentType } from "react";
import { lazy } from "react";

const CHUNK_RETRY_KEY = "dks-app:chunk-reload";

const isChunkLoadError = (error: unknown) => {
  if (!error || typeof error !== "object") {
    return false;
  }

  const message =
    "message" in error && typeof error.message === "string"
      ? error.message
      : "";

  return message.includes("ChunkLoadError") || message.includes("Loading chunk");
};

export const lazyWithRetry = <T extends ComponentType<any>>(
  importer: () => Promise<{ default: T }>
) =>
  lazy(() =>
    importer()
      .then((module) => {
        sessionStorage.removeItem(CHUNK_RETRY_KEY);
        return module;
      })
      .catch((error) => {
        if (isChunkLoadError(error)) {
          const didReload = sessionStorage.getItem(CHUNK_RETRY_KEY);
          if (!didReload) {
            sessionStorage.setItem(CHUNK_RETRY_KEY, "true");
            window.location.reload();
            return new Promise(() => undefined);
          }
        }

        throw error;
      })
  );
